import styled from 'styled-components';

export const StyledFloatingActiveUploads = styled.div`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(calc(-50% + 30px));
  width: 100%;
  max-width: 460px;
  margin: 0 auto;

  z-index: 9999;
  border: 1px solid ${({ theme }) => theme.colors.borderColor};
  border-radius: 5px 5px 0 0;
  padding: 10px 20px;

  background-color: ${({ theme }) => theme.colors.appBackground};
  display: flex;
  align-items: center;
`;
